module.exports = __webpack_public_path__ + "bg-gestao--960w--f6bcb532.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/bg-gestao--960w.jpg
// module id = 185
// module chunks = 0